<template>
  <div
    :class="{
      'd-flex': true,
      'justify-space-around': justify == 'space-around',
      'justify-space-between': justify == 'space-between',
      'flex-column': vertical,
      'flex-gap-3': vertical,
    }"
  >
    <p v-if="noRatingsFound" class="no-ratings-found">no ratings found</p>
    <div
      v-for="ratingSet in Object.keys(ratings).filter((key) => ratings[key].score != undefined)"
      :key="ratingSet"
      :class="{
        'rating-info': true,
      }"
    >
      <rating-circle-colored-ring
        :rating="ratings[ratingSet].score"
        :size="ratingCircleSize"
      ></rating-circle-colored-ring>
      <p v-if="ratings[ratingSet].count" class="rating-count">
        {{ ratings[ratingSet].count.toLocaleString() }}
        ratings
      </p>
      <p class="rating-set-label">{{ ratingSet }}</p>
    </div>
  </div>
</template>

<script>
import RatingCircleColoredRing from "../rating-circles/rating-circle-colored-ring.vue";

export default {
  name: "work-page-ratings-section",

  props: {
    vertical: {
      type: Boolean,
      default: false,
    },
    ratings: {
      type: Object,
    },
    ratingCircleSize: {
      type: Number,
      default: 100,
    },
    // Legal values: space-around space-between
    justify: {
      type: String,
      default: "space-around",
    },
  },

  components: {
    RatingCircleColoredRing,
  },

  computed: {
    noRatingsFound() {
      for (const [_, val] of Object.entries(this.ratings)) {
        if (val.score) {
          return false;
        }
      }
      return true;
    },
  },
};
</script>

<style scoped>
.rating-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 8px;
}

.rating-info > p {
  margin-bottom: 0;
  margin-top: 4px;
  text-align: center;
  line-height: 1;
  color: var(--v-text-lighten1);
}
.rating-count {
  font-size: 10px;
}
.rating-set-label {
  font-size: 14px;
}

.no-ratings-found {
  text-align: center;
  color: var(--v-text-lighten2);
  font-size: 26px;
  margin-bottom: 8px;
}

.flex-gap-3 {
  gap: 24px;
}

@media (min-width: 1264px) {
  .rating-set-label {
    font-size: 24px;
  }
}
</style>
